import { render, staticRenderFns } from "./ChecksListDesktopView.vue?vue&type=template&id=3b963b16&scoped=true&"
import script from "./ChecksListDesktopView.vue?vue&type=script&lang=js&"
export * from "./ChecksListDesktopView.vue?vue&type=script&lang=js&"
import style0 from "./ChecksListDesktopView.vue?vue&type=style&index=0&id=3b963b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b963b16",
  null
  
)

export default component.exports